import { render, staticRenderFns } from "./no-access-modal.vue?vue&type=template&id=576e0daa&"
import script from "./no-access-modal.component.ts?vue&type=script&lang=ts&"
export * from "./no-access-modal.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports